/* eslint-disable */
import React, { useState } from 'react'
import {UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Container, NavbarBrand, Navbar, Nav, NavItem, NavbarToggler, Collapse, NavLink } from 'reactstrap'
import logo from '../../assets/images/logos/logo.png'
import { Link, Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import LandingPage from '../../components/LandingPage/LandingPage'
import ScannedToTextEnglish from '../../components/Features/ScannedToTextEnglish/ScannedToTextEnglish'
import ScannedToTextHindi from '../../components/Features/ScannedToTextHIndi/ScannedToTextHindi'
import PdfToTextEnglish from '../../components/Features/PdfToTextEnglish/PdfToTextEnglish'
import PdfToTextHindi from '../../components/Features/PdfToTextHindi/PdfToTextHindi'
import PhotoToTextHindi from '../../components/Features/PhotoToTextHindi/PhotoToTextHindi'
import PhotoToTextEnglish from '../../components/Features/PhotoToTextEnglish/PhotoToTextEnglish'
import Services from '../LandingPage/Services/Services'
import HowItWorks from '../HowItWorks/HowItWorks'
import Contact from '../LandingPage/Contact/Contact'

const HeaderComponent = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => setIsOpen(!isOpen)
    return (
        <Router>
            <div id="section">
                <div className="header1 po-relative">
                    <Container>
                        <Navbar className="navbar-expand-lg h1-nav">
                        <Link to="/"><NavbarBrand><img src={logo} alt="Convext" /></NavbarBrand></Link>
                            <NavbarToggler onClick={toggle}><span className="ti-menu"></span></NavbarToggler>
                            <Collapse isOpen={isOpen} navbar id="header1">
                                <Nav navbar className="ml-auto mt-2 mt-lg-0">
                                    <NavItem className="active"><Link className="nav-link" to="/">Home</Link></NavItem>
                                    <NavItem><Link className="nav-link" to="/how-it-works">How It Works</Link></NavItem>
                                    <UncontrolledDropdown nav inNavbar>
                                        <DropdownToggle nav>
                                            Services <i className="fa fa-angle-down m-l-5"></i>
                                        </DropdownToggle>
                                        <DropdownMenu className="b-none animated fadeInUp">
                                            <DropdownItem><Link className="nav-link" to="/scanned-to-text-english">Scanned Image to text english</Link></DropdownItem>
                                            <DropdownItem><Link className="nav-link" to="/scanned-to-text-hindi">Scanned Image to text hindi</Link></DropdownItem>
                                            <DropdownItem divider />
                                            <DropdownItem><Link className="nav-link" to="/photo-to-text-english">Photo to text english</Link></DropdownItem>
                                            <DropdownItem><Link className="nav-link" to="/photo-to-text-hindi">Photo to text hindi</Link></DropdownItem>
                                            <DropdownItem divider />
                                            <DropdownItem><Link className="nav-link" to="/pdf-to-text-english">Pdf to text english</Link></DropdownItem>
                                            <DropdownItem><Link className="nav-link" to="/pdf-to-text-hindi">Pdf to text hindi</Link></DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                    <NavItem><Link className="nav-link" to="/contact">Contact</Link></NavItem>
                                    {/* <NavItem><Link className="btn btn-outline-success" to="/">Star</Link></NavItem> */}
                                </Nav>
                            </Collapse>
                        </Navbar>
                    </Container>
                </div>
            </div>
            <Switch>
                <Route exact path="/" component={LandingPage} />
                <Route exact  path="/services" component={Services} />
                <Route exact  path="/contact" component={Contact} />
                <Route exact path="/how-it-works" component={HowItWorks} />
                <Route exact path="/scanned-to-text-english" component={ScannedToTextEnglish} />
                <Route exact path="/scanned-to-text-hindi" component={ScannedToTextHindi} />
                <Route exact path="/pdf-to-text-english" component={PdfToTextEnglish} />
                <Route exact path="/pdf-to-text-hindi" component={PdfToTextHindi} />
                <Route exact path="/photo-to-text-english" component={PhotoToTextEnglish} />
                <Route exact path="/photo-to-text-hindi" component={PhotoToTextHindi} />
            </Switch>
        </Router>
    )
}

export default HeaderComponent
